module.exports = __webpack_public_path__ + "static/media/user-placeholder.1b272bbd.jpg";